import styled from 'styled-components';
import {
  size,
  mediaQueries,
  Button as BaseButton,
  colors,
  Container as BaseContainer,
} from '@everlywell/leaves';

import { animated } from 'react-spring';

const Container = styled(BaseContainer)`
  padding-top: 0;
`;

const Inner = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: ${size.xl6}px;
  border-top: 1px solid ${colors.green2};
`;

const TextContainer = styled(animated.div)`
  opacity: 0;
  transform: translateY(${size.xl3}px);
`;

const HeadlineText = styled.h2`
  font-size: 25.6px;
  line-height: ${size.xl1}px;
  letter-spacing: 0.53px;
  color: ${colors.teal6};
  margin-bottom: ${size.lg}px;
  text-align: center;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl1}px;
    font-size: ${size.xl1}px;
    line-height: ${size.xl2}px;
  }
`;

const Button = styled(BaseButton)`
  margin-bottom: ${size.xl6}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 8.125rem;
  }
`;

const Graphic = styled(animated.img)`
  width: 7rem;
  height: 7rem;
  padding-bottom: 3.5rem;
  position: absolute;
  bottom: -3.5rem;
  ${mediaQueries.forTabletHorizontalUp} {
    width: 16rem;
    height: 16rem;
    padding-bottom: 8rem;
    bottom: -8rem;
  }
`;

export { Inner, TextContainer, HeadlineText, Button, Graphic, Container };
